import {forwardRef} from 'react';

import {getGlobalButtons} from '@/services/content/appContent';
import {twx} from '@/utils/tailwindUtils';
import {ChevronLeftIcon} from '../Icons';

type BackButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
    icon?: React.ReactNode;
    alt?: string;
};

const BackButton = forwardRef<HTMLButtonElement, BackButtonProps>(({className, icon, alt, ...restProps}, ref) => {
    return (
        <button
            type='button'
            ref={ref}
            data-testid='back-button'
            className={twx(
                'flex h-11 w-11 items-center justify-center rounded-full border-0 bg-transparent p-0 text-white outline-none',
                className
            )}
            aria-label={alt ?? getGlobalButtons().backButton?.alt ?? undefined}
            {...restProps}
        >
            {icon ?? <ChevronLeftIcon />}
        </button>
    );
});

BackButton.displayName = 'BackButton';

export default BackButton;
